import script from "./ProfileIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileIcon.vue?vue&type=script&setup=true&lang=js"

import "./ProfileIcon.vue?vue&type=style&index=0&id=7090cb84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7090cb84"]])

export default __exports__